import profile from './Profile';
import security from './Security';

export default { profile, security };
